import { render, staticRenderFns } from "./EntityDetailSection.vue?vue&type=template&id=e31b9672&scoped=true"
import script from "./EntityDetailSection.vue?vue&type=script&lang=ts"
export * from "./EntityDetailSection.vue?vue&type=script&lang=ts"
import style0 from "./EntityDetailSection.vue?vue&type=style&index=0&id=e31b9672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31b9672",
  null
  
)

export default component.exports